export default function setLatAction(latitude) {
    return {
        type: 'SET_LAT',
        payload: latitude
    }
}